<div class="bg-warning-light flex gap-x-4 p-5">
  <div class="relative h-8 w-8 shrink-0 animate-spin overflow-hidden p-1">
    <div class="bg-theme-dark-gray h-full w-full rounded-full p-0.75">
      <div class="bg-warning-light h-full w-full rounded-full"></div>
    </div>
    <div class="bg-warning-light absolute top-1/2 left-1/2 h-full w-full"></div>
  </div>
  <div class="flex w-full flex-col justify-between gap-y-1">
    <span class="font-bold">Info</span>
    <span>{{ message() }}</span>
  </div>
</div>
